<div class="leader-baord-section">
    <div *ngIf="contestDetails.tournamentMatchStatus !== 'notstarted'" class="l-wrapper" id="wrapper">
        <div class="contest-leaderboard-head">
            <div class="mobile-back-btn" (click)="onClickViewContest()">
               <span class="mr-2"><img src="../../../assets/img/contests/left-icon.svg" alt=""></span> Back
            </div>
            <!-- <div class="c-headline contest-headding">

                
            </div> -->
        </div>

       
        <div class="c-headline contest-player-details"  [ngClass]="(isContestDoubles) ? 'double-contest-main-div' : 'single-contest-main-div' ">
            <h4 class="c-headline__title">
                <small class="u-text--secondary">{{contestDetails?.tournamentName}}
                   {{currentYear}} ({{contestDetails?.tournamentCategoryName}})</small>
                   <!-- <span class="apt-heading">
                   </span> -->
           </h4> 

            
            <!-- <span *ngIf="!matchFinishStatus" class="c-chip c-chip--success">Match Started</span>
            <span *ngIf="matchFinishStatus" class="c-chip c-chip--success">Match Finished</span> -->
            <!-- <span class="c-chip c-chip--success" *ngIf="contestDetails.tournamentMatchStatus === 'inprogress'">In
                Progress</span> -->
                <span class="live-btn" *ngIf="contestDetails.tournamentMatchStatus === 'inprogress'"><img src="../../../assets/img/contests/1291000e120f523d7c1e1bcb8540d25c.gif" alt=""></span>
                
            <span class=" chip-div c-chip c-chip--success" *ngIf="contestDetails.tournamentMatchStatus === 'notstarted'">Match Not
                Started</span>
            <!-- <span class="c-chip c-chip--success" *ngIf="contestDetails.tournamentMatchStatus === 'finished'">Match
                Finished</span> -->
                <span class="c-chip c-chip--success chip-div" *ngIf="contestDetails.tournamentMatchStatus === 'finished' && !contestDetails.prizeDistributionDone">In Review</span>
            <span class="chip-div c-chip c-chip--success chip-div" *ngIf="contestDetails.tournamentMatchStatus === 'finished' && contestDetails.prizeDistributionDone">Completed</span>
            <span class=" chip-div c-chip c-chip--success chip-div" *ngIf="contestDetails.tournamentMatchStatus === 'canceled'">
                Canceled</span>
                
            <!-- <h4>
                <span class="apt-heading">
                    <div class="user-image">
                       
                        <p-avatarGroup styleClass="mb-3">
                            <p-avatar image="{{contestDetails?.player1Image}}" size="large" shape="circle"></p-avatar>

                        </p-avatarGroup>
                        
                    </div>
                    <span class="palyer-name">
                        {{ (contestDetails?.player1Name) ? contestPlayerName(contestDetails?.player1Name) : ''}}
                    </span>
                </span>
                <span class="vs">Vs</span>
                <span class="apt-heading">
                    <div class="user-image">
                        
                        <p-avatarGroup styleClass="mb-3">
                            <p-avatar image="{{contestDetails?.player2Image}}" size="large" shape="circle"></p-avatar>

                        </p-avatarGroup>
                  
                    </div>
                    <span class="palyer-name">
                        {{ (contestDetails?.player2Name) ? contestPlayerName(contestDetails?.player2Name) : ''}}
                    </span>
                </span>
            </h4> -->
         
            <!-- <div class="match-details">
                <h3>Prize Pool <span
                        *ngIf="contestDetails?.updatedPoolCoins !== null && contestDetails?.updatedPoolCoins > 0">{{contestDetails?.updatedPoolCoins}}
                        TPL Coins
                    </span>
                    <span
                        *ngIf="contestDetails?.updatedPoolCash !== null && contestDetails?.updatedPoolCash > 0">{{contestDetails?.updatedPoolCash}}
                        TPL Cash
                    </span>
                </h3>
            </div> -->
            <!-- <div>
                <span>
                    <button class="match-stats-btn" pButton (click)="onClickMatchStats(contestDetails?.matchId)">
                        View Match Stats 
                    </button>
                </span>
                <span class="total-list mobile fw-bold">Total Entries:{{totalRecords}}</span>  
            </div> -->
  
        <div class="players-main-parent-div" >
            <div class="palyer-main-details" *ngIf="isContestDoubles">
                <div class="main-player-div">
                    <img src="{{contestDetails?.player1Image}}" alt="" class="single-div">
                </div>
                    <div class="main-details details">
                        <span class="palyer-name">
                            {{ (contestDetails?.player1Name) ? contestPlayerName(contestDetails?.player1Name) : ''}}
                        </span>
                        <span class="vs-tag">Vs</span>
                        <span class="palyer-name">
                            {{ (contestDetails?.player2Name) ? contestPlayerName(contestDetails?.player2Name) : ''}}
                        </span>
                    </div>
                <div class="main-player-div">
                    <img src="{{contestDetails?.player2Image}}" alt="" class="single-div">
                </div>
            </div>
            <div class="palyer-main-details" *ngIf="!isContestDoubles">
                <div class="main-player-div">
                    <img src="{{contestDetails?.player1Image}}" alt="" class="single-div">
                </div>
                    <div class="main-details details">
                        <span class="palyer-name">
                            {{ (contestDetails?.player1Name) ? contestPlayerName(contestDetails?.player1Name) : ''}}
                        </span>
                        <span class="vs-tag">Vs</span>
                        <span class="palyer-name">
                            {{ (contestDetails?.player2Name) ? contestPlayerName(contestDetails?.player2Name) : ''}}
                        </span>
                    </div>
                <div class="main-player-div">
                    <img src="{{contestDetails?.player2Image}}" alt="" class="single-div">
                </div>
            </div>
           
          </div>
        </div>
        <div class="palyer-details-main-image-div" >
            <div class="players-main-parent-div">
                <div class="palyer-main-details m-0 double-div-changes">
                    <div class="main-player-div hidden">
                        <img src="{{contestDetails?.player1Image}}" alt="" class="single-div">
                    </div>
                        <div class="main-details">
                            <div class="main-btn-section">
                                <div class="match-details">
                                    <h3>Prize Pool <span
                                            *ngIf="contestDetails?.updatedPoolCoins !== null && contestDetails?.updatedPoolCoins > 0">{{contestDetails?.updatedPoolCoins}}
                                            TPL Coins
                                        </span>
                                        <span
                                            *ngIf="contestDetails?.updatedPoolCash !== null && contestDetails?.updatedPoolCash > 0">
                                            <i class='bx bx-rupee'></i>{{contestDetails?.updatedPoolCash}}
                                        </span>
                                    </h3>
                                </div>
                                <span>
                                    <button pButton (click)="onClickMatchStats(contestDetails?.matchId)">
                                        View Match Stats
                                    </button>
                                </span>
                                <span class="total-list mobile fw-bold">Number Of Entries - {{totalRecords}}</span>
                                
                            </div>
                        </div>
                    <div class="main-player-div hidden">
                        <img src="{{contestDetails?.player2Image}}" alt="" class="single-div">
                    </div>
                </div>
                
              </div>
        </div>
       
          <div class="pagination-div-main d-flex desktop">
            <span class="total-list desktop">Total Entries - {{totalRecords}}</span>
        </div>
        <p-tabView [activeIndex]="activeTabIndex">
            <p-tabPanel header="Winnings">
                <!-- <div class="col-md-12 p-p-0"> -->
                     <div class="col-md-12 heading-tab-div">
                        <p class="fs-5 fw-bold Pool-heading">Contest Prize Pool Structure</p>
                    </div>
                    <table class="table table-striped c-table">
                        <thead>
                            <tr>
                                <th scope="col" class="entries-position">Position</th> 
                                <th scope="col" class="entries-position" *ngIf="twoToFour">2 to 4 <br
                                        class="mobile-version-br">Entries</th>
                                <th scope="col" class="entries-position" *ngIf="fiveToSeven"> 5 to 7 <br class="mobile-version-br">
                                    Entries</th>
                                <th scope="col" class="entries-position" *ngIf="eightToTen">8 to 10 <br
                                        class="mobile-version-br">Entries</th>
                                <th scope="col" class="entries-position" *ngIf="elevenToThirteen">11 to 13 <br
                                        class="mobile-version-br">Entries</th>
                                <th scope="col" class="entries-position" *ngIf="fourteenToEighteen">14 to 18 <br
                                        class="mobile-version-br">Entries</th>
                                <th scope="col" class="entries-position" *ngIf="nineteenToTwentySeven">19 to 27 <br
                                        class="mobile-version-br">Entries</th>
                                <th scope="col" class="entries-position" *ngIf="twentyEightToThirtySix">28 to 36 <br
                                        class="mobile-version-br">Entries</th>
                                <th scope="col" class="entries-position" *ngIf="thirtySevenToFifty">37 to 50 <br
                                        class="mobile-version-br">Entries</th>
                                <th scope="col" class="entries-position" *ngIf="fiftyOnePlus">51+ <br
                                        class="mobile-version-br">Entries</th>
                            </tr>
                        </thead>
                        <tbody>
                           
                            <tr
                                *ngIf="twoToFour || fiveToSeven || eightToTen || elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">1st</th>
                                <td class="table-data" *ngIf="twoToFour">100%</td>
                                <td class="table-data" *ngIf="fiveToSeven">65%</td>
                                <td class="table-data" *ngIf="eightToTen">50%</td>
                                <td class="table-data" *ngIf="elevenToThirteen">40%</td>
                                <td class="table-data" *ngIf="fourteenToEighteen">40%</td>
                                <td class="table-data" *ngIf="nineteenToTwentySeven">33%</td>
                                <td class="table-data" *ngIf="twentyEightToThirtySix">29%</td>
                                <td class="table-data" *ngIf="thirtySevenToFifty">28%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">27%</td>
                            </tr>
                            <tr
                                *ngIf="fiveToSeven || eightToTen || elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">2nd</th>
                                <td class="table-data" *ngIf="fiveToSeven">35%</td>
                                <td class="table-data" *ngIf="eightToTen">30%</td>
                                <td class="table-data" *ngIf="elevenToThirteen">30%</td>
                                <td class="table-data" *ngIf="fourteenToEighteen">23%</td>
                                <td class="table-data" *ngIf="nineteenToTwentySeven">20%</td>
                                <td class="table-data" *ngIf="twentyEightToThirtySix">18%</td>
                                <td class="table-data" *ngIf="thirtySevenToFifty">16%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">15%</td>
                            </tr>
                            <tr
                                *ngIf="eightToTen || elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">3rd</th>
                                <td class="table-data" *ngIf="eightToTen">20%</td>
                                <td class="table-data" *ngIf="elevenToThirteen">20%</td>
                                <td class="table-data" *ngIf="fourteenToEighteen">16%</td>
                                <td class="table-data" *ngIf="nineteenToTwentySeven">15%</td>
                                <td class="table-data" *ngIf="twentyEightToThirtySix">14%</td>
                                <td class="table-data" *ngIf="thirtySevenToFifty">13%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">13%</td>
                            </tr>
                            <tr
                                *ngIf="elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">4th</th>
                                <td class="table-data" *ngIf="elevenToThirteen">10%</td>
                                <td class="table-data" *ngIf="fourteenToEighteen">12%</td>
                                <td class="table-data" *ngIf="nineteenToTwentySeven">11%</td>
                                <td class="table-data" *ngIf="twentyEightToThirtySix">11%</td>
                                <td class="table-data" *ngIf="thirtySevenToFifty">10%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">10%</td>
                            </tr>
                            <tr
                                *ngIf="fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">5th</th>
                                <td class="table-data" *ngIf="fourteenToEighteen">9%</td>
                                <td class="table-data" *ngIf="nineteenToTwentySeven">8%</td>
                                <td class="table-data" *ngIf="twentyEightToThirtySix">9%</td>
                                <td class="table-data" *ngIf="thirtySevenToFifty">9%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">9%</td>
                            </tr>
                            <tr *ngIf="nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">6th</th>
                                <td class="table-data" *ngIf="nineteenToTwentySeven">7%</td>
                                <td class="table-data" *ngIf="twentyEightToThirtySix">8%</td>
                                <td class="table-data" *ngIf="thirtySevenToFifty">8%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">8%</td>
            
                            </tr>
                            <tr *ngIf="nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">7th</th>
                                <td class="table-data" *ngIf="nineteenToTwentySeven">6%</td>
                                <td class="table-data" *ngIf="twentyEightToThirtySix">6%</td>
                                <td class="table-data" *ngIf="thirtySevenToFifty">7%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">7%</td>
                            </tr>
                            <tr *ngIf="twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">8th</th>
                                <td class="table-data" *ngIf="twentyEightToThirtySix">5%</td>
                                <td class="table-data" *ngIf="thirtySevenToFifty">5%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">5%</td>
                            </tr>
                            <tr *ngIf="thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">9th</th>
                                <td class="table-data" *ngIf="thirtySevenToFifty">4%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">4%</td>
                            </tr>
                            <tr *ngIf="fiftyOnePlus">
                                <th scope="row" class="entries-position">10th</th>
                                <td class="table-data" *ngIf="fiftyOnePlus">2%</td>
                            </tr>
                        </tbody>
                    </table>
                <!-- </div> -->
            </p-tabPanel>
            <p-tabPanel header="Leaderboard">
                <div class="leader-board-main-div">
                    <div class="table-div">
                        <table class="c-table">
                            <thead class="c-table__head">
                                <tr class="c-table__head-row">
                                    <th class="c-table__head-cell u-text--center header-place PlaceTD">Rank</th>
                                    <th class="c-table__head-cell PlayerName ">Username</th>
                                    <!-- <th class="c-table__head-cell u-text--right Points blank_TD"></th> -->
                                    <th class="c-table__head-cell u-text--right Points">Points</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!--add active class in tr active in this  c-table__row class to highlight player -->
                                <tr *ngFor="let user of contestUserList; let i = index" class="c-table__row ">
                                    <div [ngClass]="userId === user.userId ? 'highlight-user' : ''" style="width: 100%;padding: 5px;">
                                        <td class="c-table__head-cell u-text--center header-place PlaceTD">
                                            <span class="c-place c-place--first">#{{user.playerRank}}</span>
                                        </td>
                                        <td class="c-table__head-cell PlayerName">
                                            <div class="user-details-div" (click)="leaderboardModal(user)">
                                                <div class="media">
                                                    <!-- <div class="media-left">
                                                        <div class="user-image">
                                                            <img src="{{user.userImage}}" alt="">
                                                        </div>
                                                    </div> -->
                                                    <div class="media-body">
                                                        <div class="user-name">
                                                            <h4>{{user.userName}}</h4>
                                                            <!--If Need to show win amount just uncomment below code--->
                                                            <span
                                                                *ngIf="user.totalCashPrizeWon !== null && user.totalCashPrizeWon != undefined"
                                                                class="wining-amount">{{user.totalCashPrizeWon}} Cash
                                                            </span>
                                                            <span
                                                                *ngIf="user.totalContestCashPrizeWon !== null && user.totalContestCashPrizeWon != undefined"
                                                                class="wining-amount">{{user.totalContestCashPrizeWon}} Cash
                                                            </span>
                                                            <span
                                                                *ngIf="user.totalCoinPrizeWon !== null && user.totalCoinPrizeWon !== undefined"
                                                                class="wining-amount">{{user.totalCoinPrizeWon}} Coins
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <!-- <td class="c-table__head-cell u-text--right Points blank_TD"></td> -->
                                        <td class="c-table__head-cell u-text--right Points">
                                            <strong>{{user.totalPoints}}</strong>
                                        </td>
                                    </div>
                                </tr>
                                <!-- <tr class="c-table__row ">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span
                                            class="c-place c-place--second">2</span></td>
                                    <td class="c-table__cell c-table__cell--name">Sergio Pérez<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>54</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span
                                            class="c-place c-place--third">3</span></td>
                                    <td class="c-table__cell c-table__cell--name">Fernando Alonso<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>45</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">4</span>
                                    </td>
                                    <td class="c-table__cell c-table__cell--name">Lewis Hamilton<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>38</strong></td>
                                </tr>
                                <tr class="c-table__row active">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">5</span>
                                    </td>
                                    <td class="c-table__cell c-table__cell--name">Carlos Sainz<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>20</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">6</span>
                                    </td>
                                    <td class="c-table__cell c-table__cell--name">Lance Stroll<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>20</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">7</span>
                                    </td>
                                    <td class="c-table__cell c-table__cell--name">George Russell<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>18</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">8</span>
                                    </td>
                                    <td class="c-table__cell c-table__cell--name">Lando Norris<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>8</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">9</span>
                                    </td>
                                    <td class="c-table__cell c-table__cell--name">Nico Hülkenberg<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>6</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">10</span></td>
                                    <td class="c-table__cell c-table__cell--name">Charles Leclerc<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>6</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">11</span></td>
                                    <td class="c-table__cell c-table__cell--name">Valtteri Bottas<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>4</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">12</span></td>
                                    <td class="c-table__cell c-table__cell--name">Esteban Ocon<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>4</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">13</span></td>
                                    <td class="c-table__cell c-table__cell--name">Oscar Piastri<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>4</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">14</span></td>
                                    <td class="c-table__cell c-table__cell--name">Pierre Gasly<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>4</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">15</span></td>
                                    <td class="c-table__cell c-table__cell--name">Guanyu Zhou<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>2</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">16</span></td>
                                    <td class="c-table__cell c-table__cell--name">Yuki Tsunoda<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>1</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">17</span></td>
                                    <td class="c-table__cell c-table__cell--name">Kevin Magnussen<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>1</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">18</span></td>
                                    <td class="c-table__cell c-table__cell--name">Alexander Albon<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>1</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">19</span></td>
                                    <td class="c-table__cell c-table__cell--name">Logan Sargeant<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>0</strong></td>
                                </tr>
                                <tr class="c-table__row">
                                    <td class="c-table__cell c-table__cell--place u-text--center"><span class="c-place">20</span></td>
                                    <td class="c-table__cell c-table__cell--name">Nyck de Vries<br></td>
                                    <td class="c-table__cell c-table__cell--count"></td>
                                    <td class="c-table__cell c-table__cell--points u-text--right"><strong>0</strong></td>
                                </tr> -->
                            </tbody>
                            <!-- <p-paginator appendTo="body" [rows]="10" #paginator [totalRecords]="totalRecords" [pageSize]="3"
                                (onPageChange)="loadContest($event, mode)" [rowsPerPageOptions]=" pagination"></p-paginator> -->
                        </table>
                    </div>
                </div>
               
            
                <div class="main-pagination">
                    <p-paginator appendTo="body" [rows]="10" #paginator [totalRecords]="totalRecords" [pageSize]="3"
                    (onPageChange)="loadContest($event, mode)" [rowsPerPageOptions]=" pagination"></p-paginator>
                </div>
            </p-tabPanel>
        </p-tabView>
    </div>
    <div *ngIf="contestDetails.tournamentMatchStatus === 'notstarted'" class="l-wrapper" id="wrapper">
        <div class="contest-leaderboard-head">
            <div class="mobile-back-btn" (click)="onClickViewContest()">
               <span class="mr-2"><img src="../../../assets/img/contests/left-icon.svg" alt=""></span> Back
            </div>
            <!-- <div class="c-headline contest-headding">
             
               
            </div> -->
        </div>
       
        <div class="c-headline contest-player-details"  [ngClass]="(isContestDoubles) ? 'double-contest-main-div' : 'single-contest-main-div' ">
            <h4 class="c-headline__title">
                 <small class="u-text--secondary">{{contestDetails?.tournamentName}}
                    {{currentYear}} ({{contestDetails?.tournamentCategoryName}})</small>
                    <!-- <span class="apt-heading">
                    </span> -->
            </h4>
            <!-- <span class="c-chip c-chip--success">Match not start</span> -->
            <span class=" chip-div c-chip c-chip--success ">Yet to Start</span>
            <!-- <span class="live-btn"><img src="../../../assets/img/contests/1291000e120f523d7c1e1bcb8540d25c.gif" alt=""></span> -->

          <div class="players-main-parent-div" >
            <div class="palyer-main-details" *ngIf="isContestDoubles">
                <div class="main-player-div">
                    <img src="{{contestDetails?.player1Image}}" alt="" class="single-div">
                </div>
                    <div class="main-details details">
                        <span class="palyer-name">
                            {{ (contestDetails?.player1Name) ? contestPlayerName(contestDetails?.player1Name) : ''}}
                        </span>
                        <span class="vs-tag">Vs</span>
                        <span class="palyer-name">
                            {{ (contestDetails?.player2Name) ? contestPlayerName(contestDetails?.player2Name) : ''}}
                        </span>
                    </div>
                <div class="main-player-div">
                    <img src="{{contestDetails?.player2Image}}" alt="" class="single-div">
                </div>
            </div>
            <div class="palyer-main-details" *ngIf="!isContestDoubles">
                <div class="main-player-div">
                    <img src="{{contestDetails?.player1Image}}" alt="" class="single-div">
                </div>
                    <div class="main-details details">
                        <span class="palyer-name">
                            {{ (contestDetails?.player1Name) ? contestPlayerName(contestDetails?.player1Name) : ''}}
                        </span>
                        <span class="vs-tag">Vs</span>
                        <span class="palyer-name">
                            {{ (contestDetails?.player2Name) ? contestPlayerName(contestDetails?.player2Name) : ''}}
                        </span>
                    </div>
                <div class="main-player-div">
                    <img src="{{contestDetails?.player2Image}}" alt="" class="single-div">
                </div>
            </div>
          </div>
        </div>
        
        <div class="players-main-parent-div">
            <div class="palyer-main-details m-0">
                <div class="main-player-div hidden">
                    <img src="{{contestDetails?.player1Image}}" alt="" class="single-div">
                </div>
                    <div class="main-details">
                        <div class="main-btn-section">
                            <div class="match-details">
                                <h3>Prize Pool <span
                                        *ngIf="contestDetails?.updatedPoolCoins !== null && contestDetails?.updatedPoolCoins > 0">{{contestDetails?.updatedPoolCoins}}
                                        TPL Coins
                                    </span>
                                    <span
                                        *ngIf="contestDetails?.updatedPoolCash !== null && contestDetails?.updatedPoolCash > 0">
                                        <i class='bx bx-rupee'></i> {{contestDetails?.updatedPoolCash}}
                                    </span>
                                </h3>
                            </div>
                            <span>
                                <button pButton (click)="onClickMatchStats(contestDetails?.matchId)">
                                    View Match Stats
                                </button>
                            </span>
                            <span class="total-list mobile fw-bold">Number Of Entries - {{totalRecords}}</span>
                            
                        </div>
                    </div>
                <div class="main-player-div hidden">
                    <img src="{{contestDetails?.player2Image}}" alt="" class="single-div">
                </div>
            </div>
          </div>

        <div class="pagination-div-main d-flex desktop">
            <span class="total-list desktop">Total Entries - {{totalRecords}}</span>
        </div>
    
        

        <p-tabView [activeIndex]="activeTabIndex">
            <p-tabPanel header="Winnings">
                <!-- <div class="col-md-12 p-p-0"> -->
                    <div class="col-md-12 heading-tab-div">
                        <p class="fs-5 fw-bold Pool-heading">Contest Prize Pool Structure</p>
                    </div>
                    <table class="table table-striped c-table">
                        <thead>
                            <tr>
                                <th scope="col" class="entries-position">Position</th>
                                <th scope="col" class="entries-position" *ngIf="twoToFour">2 to 4 <br
                                        class="mobile-version-br">Entries</th>
                                <th scope="col" class="entries-position" *ngIf="fiveToSeven"> 5 to 7 <br class="mobile-version-br">
                                    Entries</th>
                                <th scope="col" class="entries-position" *ngIf="eightToTen">8 to 10 <br
                                        class="mobile-version-br">Entries</th>
                                <th scope="col" class="entries-position" *ngIf="elevenToThirteen">11 to 13 <br
                                        class="mobile-version-br">Entries</th>
                                <th scope="col" class="entries-position" *ngIf="fourteenToEighteen">14 to 18 <br
                                        class="mobile-version-br">Entries</th>
                                <th scope="col" class="entries-position" *ngIf="nineteenToTwentySeven">19 to 27 <br
                                        class="mobile-version-br">Entries</th>
                                <th scope="col" class="entries-position" *ngIf="twentyEightToThirtySix">28 to 36 <br
                                        class="mobile-version-br">Entries</th>
                                <th scope="col" class="entries-position" *ngIf="thirtySevenToFifty">37 to 50 <br
                                        class="mobile-version-br">Entries</th>
                                <th scope="col" class="entries-position" *ngIf="fiftyOnePlus">51+ <br
                                        class="mobile-version-br">Entries</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngIf="twoToFour || fiveToSeven || eightToTen || elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">1st</th>
                                <td class="table-data" *ngIf="twoToFour">100%</td>
                                <td class="table-data" *ngIf="fiveToSeven">65%</td>
                                <td class="table-data" *ngIf="eightToTen">50%</td>
                                <td class="table-data" *ngIf="elevenToThirteen">40%</td>
                                <td class="table-data" *ngIf="fourteenToEighteen">40%</td>
                                <td class="table-data" *ngIf="nineteenToTwentySeven">33%</td>
                                <td class="table-data" *ngIf="twentyEightToThirtySix">29%</td>
                                <td class="table-data" *ngIf="thirtySevenToFifty">28%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">27%</td>
                            </tr>
                            <tr
                                *ngIf="fiveToSeven || eightToTen || elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">2nd</th>
                                <td class="table-data" *ngIf="fiveToSeven">35%</td>
                                <td class="table-data" *ngIf="eightToTen">30%</td>
                                <td class="table-data" *ngIf="elevenToThirteen">30%</td>
                                <td class="table-data" *ngIf="fourteenToEighteen">23%</td>
                                <td class="table-data" *ngIf="nineteenToTwentySeven">20%</td>
                                <td class="table-data" *ngIf="twentyEightToThirtySix">18%</td>
                                <td class="table-data" *ngIf="thirtySevenToFifty">16%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">15%</td>
                            </tr>
                            <tr
                                *ngIf="eightToTen || elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">3rd</th>
                                <td class="table-data" *ngIf="eightToTen">20%</td>
                                <td class="table-data" *ngIf="elevenToThirteen">20%</td>
                                <td class="table-data" *ngIf="fourteenToEighteen">16%</td>
                                <td class="table-data" *ngIf="nineteenToTwentySeven">15%</td>
                                <td class="table-data" *ngIf="twentyEightToThirtySix">14%</td>
                                <td class="table-data" *ngIf="thirtySevenToFifty">13%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">13%</td>
                            </tr>
                            <tr
                                *ngIf="elevenToThirteen || fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">4th</th>
                                <td class="table-data" *ngIf="elevenToThirteen">10%</td>
                                <td class="table-data" *ngIf="fourteenToEighteen">12%</td>
                                <td class="table-data" *ngIf="nineteenToTwentySeven">11%</td>
                                <td class="table-data" *ngIf="twentyEightToThirtySix">11%</td>
                                <td class="table-data" *ngIf="thirtySevenToFifty">10%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">10%</td>
                            </tr>
                            <tr
                                *ngIf="fourteenToEighteen || nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">5th</th>
                                <td class="table-data" *ngIf="fourteenToEighteen">9%</td>
                                <td class="table-data" *ngIf="nineteenToTwentySeven">8%</td>
                                <td class="table-data" *ngIf="twentyEightToThirtySix">9%</td>
                                <td class="table-data" *ngIf="thirtySevenToFifty">9%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">9%</td>
                            </tr>
                            <tr *ngIf="nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">6th</th>
                                <td class="table-data" *ngIf="nineteenToTwentySeven">7%</td>
                                <td class="table-data" *ngIf="twentyEightToThirtySix">8%</td>
                                <td class="table-data" *ngIf="thirtySevenToFifty">8%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">8%</td>
            
                            </tr>
                            <tr *ngIf="nineteenToTwentySeven || twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">7th</th>
                                <td class="table-data" *ngIf="nineteenToTwentySeven">6%</td>
                                <td class="table-data" *ngIf="twentyEightToThirtySix">6%</td>
                                <td class="table-data" *ngIf="thirtySevenToFifty">7%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">7%</td>
                            </tr>
                            <tr *ngIf="twentyEightToThirtySix || thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">8th</th>
                                <td class="table-data" *ngIf="twentyEightToThirtySix">5%</td>
                                <td class="table-data" *ngIf="thirtySevenToFifty">5%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">5%</td>
                            </tr>
                            <tr *ngIf="thirtySevenToFifty || fiftyOnePlus">
                                <th scope="row" class="entries-position">9th</th>
                                <td class="table-data" *ngIf="thirtySevenToFifty">4%</td>
                                <td class="table-data" *ngIf="fiftyOnePlus">4%</td>
                            </tr>
                            <tr *ngIf="fiftyOnePlus">
                                <th scope="row" class="entries-position">10th</th>
                                <td class="table-data" *ngIf="fiftyOnePlus">2%</td>
                            </tr>
                        </tbody>
                    </table>
                <!-- </div> -->
            </p-tabPanel>
            <p-tabPanel header="Leaderboard">
                <div class="leader-board-main-div">
                    <div class="table-div">
                        <table class="c-table">
                            <thead class="c-table__head">
                                <tr class="c-table__head-row">
                                    <th class="c-table__head-cell u-text--center header-place ">Rank</th>
                                    <th class="c-table__head-cell PlayerName">Name</th> 
                                    <th class="c-table__head-cell u-text--right Points">Points</th>
                                </tr>
                            </thead>
                            <tbody class="Waiting-body">
                                 <!-- <tr rowspan="4" class="waiting-row">
                                    <td rowspan="4">
                                         <div class="waiting-message">
                                            <img src="assets/img/players/waiting.gif" alt="" width="100px" height="100px"
                                                class="d-block">
                                            <span class="display-6">Waiting for the match to begin</span>
                                        </div>
                                    </td>
                                </tr>  -->
                        

                                <tr *ngFor="let user of contestUserList; let i = index" class="c-table__row ">
                                    <div [ngClass]="userId === user.userId ? 'highlight-user' : ''" style="width: 100%;padding: 0px;" class="highlight-div">
                                        <td class="c-table__head-cell u-text--center header-place PlaceTD">
                                            <span class="c-place c-place--first">{{''}} #1</span>
                                        </td>
                                        <td class="c-table__head-cell PlayerName">
                                            <div class="user-details-div" (click)="leaderboardModal(user)">
                                                <div class="media">
                                                    <!-- <div class="media-left">
                                                        <div class="user-image">
                                                            <img src="{{user.userImage}}" alt="">
                                                        </div>
                                                    </div> -->
                                                    <div class="media-body">
                                                        <div class="user-name">
                                                            <h4>{{user.userName}}</h4>
                                                            <!--If Need to show win amount just uncomment below code--->
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td> 
                                        <td class="c-table__head-cell u-text--right Points">
                                            <strong>{{''}} - </strong>
                                        </td>
                                    </div>
                                </tr>
                                
                            </tbody>
                        </table>
                    </div>
                </div>
                       
                        <div class="main-pagination">
                            <p-paginator appendTo="body" [rows]="10" #paginator [totalRecords]="totalRecords" [pageSize]="3"
                            (onPageChange)="loadContest($event, mode)" [rowsPerPageOptions]=" pagination"></p-paginator>
                        </div>
            </p-tabPanel>
        </p-tabView>
    </div>
    <div class="overly-black"></div>
</div>
<!-- <div id="joinMsg" style="display: none;">
    <h1>Please join contest.</h1>
</div> -->
<p-dialog [(visible)]="userResult" [modal]="true" [style]="{ width: '500px', height: '74vh'  }" [draggable]="false"
    [resizable]="false" id="leader-board-details">
    <ng-template pTemplate="header">
        <div class="col-md-12 points-button">
            <button>
                <img src={{this.selectedUserData?.userImage}} alt="" class="user-img">
            </button>
        </div>
        <div class="username">
            <div class="name">{{this.selectedUserData?.userName}}</div>
            <div class="point-total">
                {{popupmodaltotalpoints}} <sub>Pts</sub>
            </div>
        </div>
    </ng-template>


    <div class="total-points">
        <div class="winner-div">

            <!-- <div class="Total-points-div-final">
                <h2>
                    {{this.selectedUserData?.totalPoints}}
                </h2>
            </div> -->

        </div>
    </div>
    <div class="leader-board-details">

        <div class="selected-player">
            <div class="image">
                <img src={{this.selectedUserImage}} alt="">
            </div>
            <div class="player-name">
                <h5>{{this.selectedUserData?.playerName}}</h5>
            </div>
            <div class="headstart-name">
                <h6 class="headstart-text">Head Start Points : {{playerRanking ==undefined ? '0' :playerRanking }} * {{this.higherlowerranking !== null && this.higherlowerranking !== undefined ? this.higherlowerranking : '0'
                }} = {{this.selectedUserData?.headStartPoints}} Points</h6>
            </div>
        </div>

        <div class="points-table-div col-md-12">
            <!-- <h4>Contest Questions</h4> -->

            <table style="width:100%">
                <tr>
                    <th class="qs-text heading-text">Contest Questions</th>
                    <th class="qs-text heading-text">Points</th>
                    <th class="qs-text heading-text">Players Points</th>
                    <th class="qs-text heading-text">Total Points</th>
                </tr>
                <tr *ngFor="let question of this.selectedUserData?.questionAnswerData">
                    <td class="qs-text heading-text">{{ question?.question }}</td>
                    <td class="point-text">{{ (question?.points === 15) ? 10 : question?.points }}</td>
                    <td class="point-text">{{ question?.playerPoints }}</td>
                    <td class="point-text">{{ question?.actualPoints }}</td>
                </tr>
                <tr>
                    <td>

                    </td>
                    <td>

                    </td>
                    <td>

                    </td>
                    <td style="padding: 0px;">
                        <div class="total-point">
                            {{popupmodaltotalpoints}}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <!-- <img src="../../../assets/img/acadmy/court.png" alt=""> -->


    </div>
</p-dialog>
<p-dialog id="terms" [closable]="true" [(visible)]="showContestDetail" (onHide)="closeContestModal()" [modal]="true"
    [style]="{width: '500px'}" header="Point Details" [breakpoints]="{'960px': '60vw', '640px': 'calc(100% - 20px)'}"
    [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div class="modal-content team qize-section question-list quize-description">
        <div class="modal-body modal-Detals">
            <div class="col-md-12 quiz-main-body">
                <div class="qizeheader ">
                    <div class="mobile-version">
                        <!-- <a onclick="history.back()" class="left-title mobile">
                            <i class='bx bx-left-arrow-alt'></i> Back
                        </a> -->
                    </div>
                    <div class="left-title w-auto"> </div>
                </div>
                <div class="content">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-sm-12 p-p-0">
                                <div class="Select-quationn-list">
                                    <p class="mb-3">Each contest will be for a single ATP or WTA match. Contest
                                        Participant
                                        will pick One Player then pick the best 3 options out of 5 to earn
                                        maximum points to win the contest.</p>
                                    <div class="mb-3">
                                        <p class="mb-3">
                                            <b>Contest Options to Select will be –</b>
                                        </p>
                                        <ul>
                                            <li>
                                                1. Total Points Won – 1 TPL Pts per Point
                                            </li>
                                            <li>
                                                2. Number of Games – 6 TPL Pts per Game Won
                                            </li>
                                            <li>
                                                3. Number of Sets won – 50 TPL Pts per Set
                                            </li>
                                            <li>
                                                4. Number of Aces – 10 TPL Pts per Ace.
                                            </li>
                                            <li>
                                                5. Break Points Won – 20 TPL Pts per Break Points Won
                                            </li>
                                        </ul>


                                    </div>


                                    <p class="mb-3">
                                        Along with the above, we will give Head Start to each player based on
                                        their World Ranking to offset the advantage of a highly seeded player to
                                        a
                                        weaker player.<br>
                                        So, (Current Ranking *2) Points will be added to the above Total.



                                    </p>


                                </div>

                            </div> <!-- End of col-sm-12 -->

                        </div> <!-- End of row -->
                    </div> <!-- ENd of container fluid -->
                </div>
            </div>
        </div>
    </div>
</p-dialog>
